import { useTheme } from '../hooks/useTheme';
import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function Header({ selectedChild }) {
  const { isDark, toggleTheme } = useTheme();
  const [time, setTime] = useState(() => {
    const now = new Date();
    return now.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', hour12: false });
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      setTime(now.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', hour12: false }));
    }, 1000 * 10); // alle 10 Sekunden aktualisieren
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="w-full bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 sticky top-0 z-40 h-14 flex items-center justify-between px-4">
      <div className="flex items-center space-x-3 flex-1 min-w-0">
        <img src="/logo.svg" alt="Baby Sleep Tracker" className="w-8 h-8 flex-shrink-0" />
        <div className="min-w-0">
          <h1 className="text-lg font-bold text-gray-900 dark:text-white tracking-tight truncate">
            Baby Sleep Tracker
          </h1>
          {selectedChild && (
            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
              {selectedChild.name}
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <span className="font-mono text-base text-gray-700 dark:text-gray-200 min-w-[48px] text-right">
          {time}
        </span>
        <button
          onClick={toggleTheme}
          className="p-1.5 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors flex-shrink-0 ml-3"
          aria-label={isDark ? 'Light mode' : 'Dark mode'}
        >
          {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </button>
      </div>
    </header>
  );
} 